import { useQuery } from '@tanstack/react-query';

import { requestServices } from '@/lib/api/request-services';

/** Contrôle d'un IBAN auprès du web service « services », dès qu'il a une longueur plausible. */
export const useIban = (iban?: string | null) =>
    useQuery({
        queryKey: ['iban', iban],
        queryFn: () => requestServices.get<Record<string, unknown>>(`/iban/${iban}`).then((res) => res.data),
        enabled: !!iban && iban.length >= 24 && iban.length <= 32,
        retry: 0,
    });
